// @ts-nocheck
/* global Lenis, gsap, ScrollTrigger */
// Premium App Scripts - 2026
document.addEventListener('DOMContentLoaded', () => {
    // Initialize Lenis Smooth Scroll
    const lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        orientation: 'vertical',
        gestureOrientation: 'vertical',
        smoothWheel: true,
        wheelMultiplier: 1,
        touchMultiplier: 2,
    });

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    // Integrate GSAP ScrollTrigger with Lenis
    gsap.registerPlugin(ScrollTrigger);

    // Optional: Connect Lenis to ScrollTrigger
    // lenis.on('scroll', ScrollTrigger.update)
    // gsap.ticker.add((time)=>{
    //   lenis.raf(time * 1000)
    // })
    // gsap.ticker.lagSmoothing(0)

    // Header Scroll Effect
    const header = document.querySelector('.premium-glass-header');
    if (header) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 50) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        });
    }

    // Hero Animations
    const heroes = document.querySelectorAll('[data-premium-hero]');
    heroes.forEach(hero => {
        const images = hero.querySelectorAll('.hero__image, .hero__video');
        const content = hero.querySelector('.hero__content-wrapper');
        const contentChildren = content ? content.querySelectorAll('.group-block-content > *') : []; // Attempt to target inner blocks

        // Parallax
        if (images.length > 0) {
            gsap.to(images, {
                yPercent: 20,
                ease: 'none',
                scrollTrigger: {
                    trigger: hero,
                    start: 'top top',
                    end: 'bottom top',
                    scrub: true
                }
            });
        }

        // Text Reveal
        if (contentChildren.length > 0) {
            gsap.fromTo(contentChildren,
                { y: 50, opacity: 0 },
                {
                    y: 0,
                    opacity: 1,
                    duration: 1.2,
                    stagger: 0.15,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: hero,
                        start: 'top 60%',
                    }
                }
            );
        } else if (content) {
            // Fallback if specific children aren't found
            gsap.fromTo(content,
                { y: 50, opacity: 0 },
                {
                    y: 0,
                    opacity: 1,
                    duration: 1.2,
                    ease: 'power3.out',
                }
            );
        }
    });


    console.log('Premium UI/UX Loaded: Lenis + GSAP Ready');
});
